'use client';
import { Box, Stack, Typography } from '@mui/material';
import { GoogleMapsEmbed } from '@next/third-parties/google';
import useIsMobile from '../../../../utils/useIsMobile';

type MapsProps = {
  places?: { label?: string; value: string; mapQuery?: string }[];
};

const Maps = ({ places }: MapsProps) => {
  const isMobile = useIsMobile();
  return (
    <Stack
      spacing={3}
      sx={{
        width: '100%',
        borderRadius: { xs: 0.5, md: 1 },
        py: { xs: 3, md: 0 },
        px: { xs: 2, md: 2 },
      }}
    >
      {places?.map(({ label, value, mapQuery }, index) => {
        if (!mapQuery) return;
        return (
          <Stack key={value + index} spacing={2}>
            <Typography variant={'h6'} component={'p'} sx={{ fontWeight: 600 }}>
              {label}
            </Typography>
            <Box
              sx={{
                borderRadius: 0.6,
                overflow: 'hidden',
                alignItems: 'stretch',
                bgcolor: 'background.paper',
                height: '100%',
              }}
            >
              <GoogleMapsEmbed
                apiKey={process.env.NEXT_PUBLIC_G_MAPS_API || ''}
                mode="place"
                height={isMobile ? 250 : 400}
                width={'100%'}
                zoom={'12'}
                q={mapQuery || value}
              />
            </Box>
          </Stack>
        );
      })}
    </Stack>
  );
};

export default Maps;
